import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { IoDocumentAttachOutline } from 'react-icons/io5';
import { MdOutlineAttachFile } from 'react-icons/md';
import { SlCloudUpload } from 'react-icons/sl';
import { FiTrash2 } from 'react-icons/fi';

import appSettings from "../../appSettings.json";
import './AttachTicket.css'
import useFetch from '../../shared/hooks/useFetch';
import isFilled from '../../shared/utilities/isFilled';

const AttachTicket = (props) => {
    const { user, adjuntoRes, setAdjuntoRes, flagAdjuntoRes, setFlagAdjuntoRes } = props
    
    const TAM_MAX = 10000000 // 10MB tam maximo del archivo a adjuntar
    const EXTENSIONALLOWED = ['PDF', 'PNG', 'JPG', 'JPEG', 'TXT', 'DOC', 'DOCX', 'XLS', 'XLSX', 'BAK', 'ZIP', 'CSV', 'XML', 'DAT', 'SQL'] 
    const[errorTamMax, setErrorTamMax] = useState(false)
    const[errorExtension, setErrorExtension] = useState(false)

    /* Llamada API metodo uploadFiles */
    const uploadFiles = `${appSettings.BASE_URL.default}/ticket/upload-file-tickets`;

    const[dataUplTicket, setDataUplTicket] = useState([])
    const[messageUplTicket, setMessageUplTicket] = useState("");
    const[successUplTicket, setSuccessUplTicket] = useState(false);

    const [bodyUplTicket, setBodyUplTicket] = useState();
    const {serviceResponse, error, loading} = useFetch(uploadFiles, {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + user.token}, 'POST', bodyUplTicket)

    useEffect(() => {
        if(!loading){
            setMessageUplTicket(serviceResponse.message);
            setSuccessUplTicket(serviceResponse.success);

            if(serviceResponse.success) { setAdjuntoRes(serviceResponse.data) }
        }
    }, [loading, serviceResponse, error])

    const[files, setFiles] = useState([]);

    useEffect(() => {
        isFilled(adjuntoRes) && setFlagAdjuntoRes(2)
        !isFilled(adjuntoRes) && setFiles([])
    }, [adjuntoRes])

    useEffect(() => {
        if(flagAdjuntoRes == 1) {attachFiles()}
    }, [flagAdjuntoRes])

    const[dragActive, setDragActive] = useState(false);
    const inputRef = useRef(null);
    
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        }
        else if(e.type === "dragleave") {
            setDragActive(false);
        }
    }
    
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if(e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFiles(e.dataTransfer.files);
        }
    }
    
    const handleChange = (e) => {
        e.preventDefault();
        if(e.target.files && e.target.files[0]) {
            handleFiles(e.target.files);
        }
    }
    
    const onButtonClick = () => {
        inputRef.current.click();
    }

    const handleFiles = (newFiles) => {
        (Array.from(newFiles)).map((newFile, cnt) => {
            if(newFile.size <= TAM_MAX)
                if(EXTENSIONALLOWED.includes(newFile.name.split('.').pop().toUpperCase()))
                    setFiles(files => [...files, newFile])
                else
                    setErrorExtension(true)
            else
                setErrorTamMax(true)
        })
    }

    const getFileArray = (file) => {
        return new Promise((acc, err) => {
            const reader = new FileReader();
            reader.onload = (event) => { acc(event.target.result) };
            reader.onerror = (err)  => { err(err) };
            reader.readAsDataURL(file);
        });
    }

    const attachFiles = async () => {
        if(files.length > 0){
            setBodyUplTicket(
                JSON.stringify(
                    await Promise.all(
                        files.map( async (file) => ({
                            name: file.name,
                            content: (String(await getFileArray(file))).substring((String(await getFileArray(file))).indexOf(',') + 1),
                            size: file.size.toString()
                        }))
                    )
                )
            )
        }
        else
        {
            setFlagAdjuntoRes(2);
        }
    }

    return (
        <div className = 'col' style={{border: "1px solid rgba(0, 0, 0, 0.25)"}}>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={!successUplTicket && !loading} onClose={() => {}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Error al subir uno de los archivos. Mensaje API: " + messageUplTicket}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={errorTamMax} onClose={() => {setErrorTamMax(false)}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"No se pueden adjuntar archivos de más de 10MB"}
                </Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'right' }} sx={{ width: '98%' }} autoHideDuration={5000} open={errorExtension} onClose={() => {setErrorExtension(false)}}>
                <Alert severity="error" sx={{ width: '100%', justifyContent:'center' }}>
                    {"Extension no permitida. Permitidas: " + EXTENSIONALLOWED}
                </Alert>
            </Snackbar>
            {(isFilled(adjuntoRes) && isFilled(files))
            ?
                <div className="row" style={{margin:"20px 10px 10px 10px"}}>
                    <div className="col">
                        <span>Los archivos estan publicados pero se relacionaran con el ticket cuando se cree el mensaje. Hasta ese momento no se pueden adjuntar más archivos</span>
                    </div>
                </div>
            :
                <div>
                    <div className="formFile" onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
                        <input ref={inputRef} type="file" className="inputFile" multiple={true} onChange={handleChange} />
                        <label className={dragActive ? "drag-active labelFile" : "labelFile"}>
                            <div className="container">
                                <div className="row" style={{justifyContent:"center", display:"flex", margin:"10px 0px"}}>
                                    <div className="col-xs-0 col-sm-0 col"></div>
                                    <button type='button' className="col-xs-12 col-sm-12 col buttonAttach" onClick={onButtonClick}><strong>Seleccionar documentos</strong></button>
                                    <div className="col-xs-0 col-sm-0 col"></div>
                                </div>
                                <div className="row" style={{alignItems:"center", display:files.length == 0 ? '' : 'none'}}>
                                    <p style={{textAlign:"center"}}>Si adjunta los documentos de esta forma la carga del ticket será más rápida</p>
                                </div>
                                <div className="row" style={{alignItems:"center", display:files.length == 0 ? '' : 'none'}}>
                                    <button type='button' className="col-xs-12 col-sm-12 col buttonAttach" onClick={onButtonClick}><IoDocumentAttachOutline/></button>
                                </div>
                                {(files.slice(0,5)).map((file, cnt) => (
                                    <div key={cnt} className="row" style={{display:files.length == 0 ? 'none' : ''}}>
                                        <div className="col">
                                            <p>{cnt == 4 ? "..." : cnt > 4 ? <></> : <span><MdOutlineAttachFile style={{margin: "0px 4px 2px 0px"}}/>{file.name}</span>}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </label>
                        { dragActive && <div className="dragFile" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div> }
                    </div>
                    <div className="row" style={{margin:"20px 10px 10px 10px"}}>
                        <div className="col">
                            <button type='button' className="buttonForm" disabled={files.length == 0} onClick={() => setFiles([])}>Limpiar<FiTrash2/></button>
                        </div>
                        <div className="col" style={{ display: "flex", justifyContent: "flex-end" }}>
                            {/*<button type='button' className="buttonForm" disabled={files.length == 0} style={{float:"right"}} onClick={() => attachFiles()}>Adjuntar<SlCloudUpload/></button>*/}
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default AttachTicket;